import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FTNewsSider from './ftNewsSider';
import FTNews from './ftNews';

class FashionAndTravel extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ftNewsSiderData, ftNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <FTNewsSider content={ftNewsSiderData} />
                <FTNews content={ftNewsData} />
            </div>
        );
    }
}

export default errorBoundary(FashionAndTravel);
